import { useLocation } from 'react-router';
import { useLocalStorage } from './useLocalStorage';

export function usePageLocalStorage<T>(
    key: string,
    initialValue: T,
): [T, (value: React.SetStateAction<T>) => void] {
    const location = useLocation();
    const localStoragePrefix = `StreamSix_${location.key}_${key}`;

    return useLocalStorage(localStoragePrefix, initialValue);
}
